import { render } from "./lightbox.vue?vue&type=template&id=156c26a2&scoped=true"
import script from "./lightbox.vue?vue&type=script&lang=js"
export * from "./lightbox.vue?vue&type=script&lang=js"

import "./lightbox.vue?vue&type=style&index=0&id=156c26a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-156c26a2"]])

export default __exports__